module.exports = __webpack_public_path__ + "img/right2.669212e9.png";